module.exports = __webpack_public_path__ + "static/media/1_A1_22.9ca989ff.png";